"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isItemActive = exports.isActiveLink = void 0;

var isActiveLink = function isActiveLink(link) {
  var index = link.route.indexOf('#');
  var search = normalizeSearch();
  var _window$location = window.location,
      pathname = _window$location.pathname,
      hash = _window$location.hash;

  if (index > 0) {
    return pathname + search + hash === link.route;
  }

  if (pathname + search === link.route) {
    return true;
  }

  return link.matchChildren && pathname.indexOf(link.route) === 0;
};

exports.isActiveLink = isActiveLink;

var isItemActive = function isItemActive(item, customFilters, customViews) {
  if (Array.isArray(item.links)) {
    return item.links.some(isActiveLink);
  }

  var subLinks = Object.keys(item.links).map(function (groupName) {
    return item.links[groupName];
  }) // flat the array
  .reduce(function (acc, val) {
    return acc.concat(val);
  }, []);
  return subLinks.some(isActiveLink) || item.name === 'moderation' && customFilters && customFilters.some(isActiveLink) || item.name === 'moderation' && customViews && customViews.some(isActiveLink);
};

exports.isItemActive = isItemActive;

var normalizeSearch = function normalizeSearch() {
  var search = window.location.search;

  if (!search) {
    return '';
  }

  var queriesToExclude = ['page', 'showMessage', 'view', 'date_range', 'date_from', 'date_till', 'roles', 'ranks', 'categories', 'content_types', 'conversion'];
  var searchQueries = search.split('?').join('').split('&');
  searchQueries = searchQueries.filter(function (query) {
    var keepQuery = true;
    queriesToExclude.forEach(function (queryToExclude) {
      if (query.startsWith(queryToExclude)) {
        keepQuery = false;
      }
    });
    return keepQuery;
  });

  if (searchQueries.length === 0) {
    return '';
  }

  return '?' + searchQueries.join('&');
};